var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fin-all-projects-page"},[_c('BackButton'),_c('FinanceAllProjectsTable',{attrs:{"items":_vm.list,"title":"All Active Projects"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }